import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  isLoggedIn =  JSON.parse(localStorage.getItem('isLoggedIn') || "false");

  constructor(private router: Router) { }

  isHomePage(): boolean {
    return this.router.url === '/home';
  }

  getFooterClasses(): string {
    return this.isHomePage() ? 'footer-bg home-footer' : 'footer-bg';
  }
}
